module.exports = __webpack_public_path__ + "img/full0-min.568a88ca.png";